import { DataState } from 'types/store/reducers/dataSources';

import { normalizeById } from 'store/utils';
import { Event } from 'types';
import { EventActions } from 'types/store/actions/events';
import { EventActionTypes } from 'types/store/actions/constants';

export const initialState: DataState<Event> = {
  data: {},
};

export default (
  state = initialState,
  action: EventActions
): DataState<Event> => {
  switch (action.type) {
    case EventActionTypes.RESET:
      return initialState;

    case EventActionTypes.LIST_ALL_SUCCESS:
    case EventActionTypes.LIST_SUCCESS: {
      const { records } = action.payload;
      const normalizedData = normalizeById(records);
      return {
        ...state,
        data: { ...state.data, ...normalizedData },
      };
    }
    default:
      return state;
  }
};
